<ng-content select="rma-toolbar"></ng-content>

<div class="full-layout-wrapper">
  <rma-header [navBrandLink]="navBrandLink"
    [noSidebar]="noSidebar"
    [client]="currentClient"
    [showBackToClientSelectionBtn]="!!currentClient">
  </rma-header>

  <div class="app-body">
    @if (!(dashboardEditModeEnabled$ | async)) {
      <ibp-sidebar-menu
        [menuNavLinks$]="sidebarMenuItems$"
        [sidebarCollapsed$]="sidebarCollapsed$">
      </ibp-sidebar-menu>
    } @else {
      <div class="sidebar inverse">
        <nav class="sidebar-nav" aria-label="Dashboard settings">
          <div class="d-block pt-3">
            <rma-dashboard-settings-global></rma-dashboard-settings-global>
            <rma-dashboard-settings-widgets></rma-dashboard-settings-widgets>
          </div>
        </nav>
      </div>
    }

    <!-- Main content -->
    <main class="main" [ngClass]="{'_collapsed': (sidebarCollapsed$ | async)}">
      <router-outlet></router-outlet>
    </main>

  </div>
  <help></help>
</div>
